import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin: 40px 0 20px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    margin: 80px 0 30px;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    margin: 64px 0 30px;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  border-bottom: 1px solid #cccccc;\n  margin: 80px 0 47px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      grid-column-start: 1;\n      grid-column-end: none;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      width: 200px;\n      height: 48px;\n      font-size: 13px;\n      line-height: 13px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  &.button {\n    width: 320px;\n    height: 68px;\n    font-size: 18px;\n    line-height: 18px;\n    margin: auto;\n    margin-bottom: 32px;\n    grid-column-start: 2;\n    grid-column-end: 2;\n    ", "\n    ", "\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  margin: 2.5rem 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    grid-gap: 16px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    grid-gap: 30px 14px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-gap: 30px 20px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n  grid-gap: 66px 42px;\n  opacity: ", ";\n  transition: opacity 0.3s ease;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { Button } from "../../../../components";
export var List = styled.div(_templateObject(), function (props) {
  return props.loading ? 0.5 : 1;
}, media.xxLargeScreen(_templateObject2()), media.largeScreen(_templateObject3()), media.mediumScreen(_templateObject4()));
export var Loader = styled.div(_templateObject5());
export var ShowMoreButton = styled(Button)(_templateObject6(), media.xxLargeScreen(_templateObject7()), media.largeScreen(_templateObject8()));
export var BorderDiv = styled.div(_templateObject9(), media.xxLargeScreen(_templateObject10()), media.xLargeScreen(_templateObject11()), media.smallScreen(_templateObject12()));